import { render } from "./AdminBase64PhotosFix.vue?vue&type=template&id=6ec11700"
import script from "./AdminBase64PhotosFix.vue?vue&type=script&lang=js"
export * from "./AdminBase64PhotosFix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__